'use client';

import { useEffect, useState } from 'react';

import posthog from 'posthog-js';

import { toClassName } from 'helpers';

import { useTranslation } from 'hooks/useTranslation';
import Icon from 'components/Icon';
import { Button } from 'components/Button';

type TProps = {
  locale: string;
};

export const cookieConsentGiven = (): any => {
  if (!localStorage.getItem('cookie_consent')) {
    return 'undecided';
  }
  return localStorage.getItem('cookie_consent');
};

const CookieConsent = (props: TProps) => {
  const { locale } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [hide, setHide] = useState(false);

  const { t } = useTranslation(locale);

  const [consentGiven, setConsentGiven] = useState('');

  const handleClickAccept = () => {
    setIsOpen(false);

    localStorage.setItem('cookie_consent', 'yes');
    setConsentGiven('yes');

    setTimeout(() => {
      setHide(true);
    }, 700);

    posthog.opt_in_capturing();
  };

  const handleClickDecline = () => {
    setIsOpen(false);

    localStorage.setItem('cookie_consent', 'no');
    setConsentGiven('no');

    setTimeout(() => {
      setHide(true);
    }, 700);

    posthog.opt_out_capturing();
  };

  useEffect(() => {
    setConsentGiven(cookieConsentGiven());
  }, []);

  useEffect(() => {
    if (consentGiven !== '') {
      posthog.set_config({
        persistence: consentGiven === 'yes' ? 'localStorage+cookie' : 'memory',
      });
    }
  }, [consentGiven]);

  useEffect(() => {
    if (cookieConsentGiven() === 'undecided') {
      setIsOpen(true);
    }
  }, []);

  return (
    <div
      className={toClassName(
        'fixed z-[200] bottom-0 left-0 right-0 sm:left-4 sm:bottom-4 w-full sm:max-w-md duration-700',
        !isOpen
          ? 'transition-[opacity,transform] translate-y-8 opacity-0 pointer-events-none'
          : 'transition-[opacity,transform] translate-y-0 opacity-100 pointer-events-auto',
        hide && 'hidden',
      )}
    >
      <div className="dark:bg-card rounded-md m-3 border border-white/10 shadow-lg bg-black text-white">
        <div className="grid gap-2">
          <div className="border-b h-14 flex items-center justify-between p-4 border-white/10">
            <h1 className="text-lg font-medium">Wij gebruiken cookies</h1>
            <Icon accessor="cookie" className="h-[1.2rem] w-[1.2rem]" />
          </div>
          <div className="p-4">
            <p className="text-sm font-normal text-start">
              Wij gebruiken trackingcookies om te begrijpen hoe je onze website
              gebruikt en om je gebruikservaring te verbeteren. Accepteer om ons
              te helpen verbeteren.
              <br />
            </p>
          </div>
          <div className="flex gap-2 p-4 py-5 border-t border-white/10">
            <button
              onClick={handleClickAccept}
              className="w-full !bg-white !text-black hover:!bg-white/80 duration-300 border border-white/10 text-sm py-1"
            >
              Accepteren
            </button>
            <button
              onClick={handleClickDecline}
              className="w-full bg-black text-white border border-white/10 hover:bg-white/10 duration-300 text-sm py-1"
              // variant="secondary"
            >
              Weigeren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
